import {Component, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'ecp-nav-drop-down',
  templateUrl: './nav-drop-down.component.html',
  styleUrls: ['./nav-drop-down.component.css'],
  animations: [
    trigger('displayState', [
      state('none', style({
        display: 'none', opacity: '0',
      })),
      state('block', style({
        display: 'block', opacity: '1',
      })),
      transition('none => block', animate('100ms linear')),
      transition('block => none', animate('80ms linear'))
    ])
  ]
})
export class NavDropDownComponent implements OnInit {
  changeOpen: Boolean = false;
  @Input() userHader = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAYAAADFniADAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAEpklEQVRYw72XTWwUZRjHf/POzO7sV7dACtKWLhCiotJIcFED4TPuoZoYNSF6kYuJCQnEgycvxrNKojExQky8ezLxVAJyICApoKF8qSC2bul229Lubrc7O1+vB1iytN3ZGQv8b7vz/N/5Pc+8H8+rEFJnr+Tj6bi+K2Wou42I2BzRxAYgCWjAnOV4Y6bl3aiY7rnyvHPy1Rd6imHfoQQNHL5Z2L46HTkU1cU79yGCyK073onirPVdsWT9tH9bn3wkUL//Ob6xd5VxVFOVN8Nm3CzHk8P5KfPIi0+vPb0sqNHxqUMdMe0LILYcoCbJSs05dqtQ+2jP1nVmKKgzl/PaM92J73VNed/vDbNVm7sVm5rlARDVBR1xjVUpHVW0ztd25aU/xqoDO/t7JwJBnbmcVzf3Jn5UhfJWq0FN2+NWYZ6q6S75XFcVNq6Jk05oLcFcT/51I1/dt6O/N98Wamp65gdNVQ62Gqxue1z7dw7b9Z+zigLP9iRIxVqDOa4cvjI6t2PP1nWV5v9F8498YfpDPyCA28VaWyAAKeGfoukbo6nKlk1r48cW/v8AavhmYX3SUI/6DWJaHuV5py1QQzXLZb7u+sYkDfXd4ZuFA0tCda+MfgnE/QZo94IlE7G9tjHdK6NHT10afbDCBcC1vyf6/SZ2Q4poF7FYfquwKabnqc7oBw9BdaUjhwmwkepqeCpdDXZodKUjR05cGFEAxPmrY1FdVQ4EMQZIepGUgB5dVTalYtrLAKIjru0AOoIYx2fqoaEKM1bg2HRcex1AJA11d1CTCJr2/1Qiqu4EEIaubg5q0rXwUGE8RkQ8DyB0TVkf1NThszu3UtII7tFV0TU4NJIUQCowVFxj/ergDcOG1TE6E8Gh7s+OlADUMJmHqVZHPFxl5b3TSxW2IythjEZEkDTa55E0VKJ6uH3Ndj2AijBtdyyUE+jrivnuP0JRyIT4zA2ZtlfOZTMlUTXd62HNSUMlHmldrYShkoiGmhUAVE33BoAozTtnQ7sBv+bF9QLdDxapwSLKNee048rg2+5jku1IKjVnEEC89lKmNFm2fg5sdiX5aRPTat2S1CyX2xO1UK1OYbZelJITcO8CSWGm/u2azsjbfsdIpeZQLFncnbMbS7elpITJssVk2SIV01jTGWFFQm+5OFxPUixZx3PZjANN7crVW4VzPauMV5oD5+su5ZrLdMXyrUwQaarCyqROR1wjFdMeamlGJ825wmx9Qy6bmXpQKYDxmfqRFUn9V6Eo4s5MnemK1bYiYeS4kmLJoliyUIDOpE73iiielBRm6581gB6qFMAvv41+7rjy40cJE6CC5xxX7mp8Olhwm7Ed+YmUnHlySEw6rnyvGWgRVC6bsYE3gOEnAFQCBnLZzMjCB4sOp1w2UwL2AucfI9AEsD+XzVxY6uGSJ2Yum5kG9gDHePQ6C2zPZTMXWwW0bQsHh0YGgK+ATcuEKQOfqkL5Zv+2Pt8bbaBedXBoJAIcBA4DW0LC3AGOA1/nspm7QQyhm+7BoZF+YADYBTwH9C0YZwq4zr3PdFLXlFN7t/aFulov+3py6uKocKVMA6iKUt23rW/Zh/t/gqqwzo9c3wUAAAAASUVORK5CYII=';


  constructor() {
  }

  ngOnInit() {
  }

}
